export interface IBsrHistory { date: string | Date; rank: number }

export interface IAgentProductHistory {
	id: string;
	status: 'available' | 'missing' | 'unavailable' | 'identity_mismatch';
	firstObservedAt?: string;
	lastObservedAt?: string;
	observationCount?: number;
	totalMonths?: number;
	monthly?: Array<{ month: string; observations: number; averageBsr: number; bestBsr: number; worstBsr: number }>;
}

export interface IAgentResearchHistory {
	source: string;
	retrievedAt: string;
	limitations: string;
	products: IAgentProductHistory[];
}

export function summarizeBsrHistory(id: string, history: IBsrHistory[] = []): IAgentProductHistory {
	const observations = (Array.isArray(history) ? history : [])
		.filter((entry) => entry?.date !== null && typeof entry?.date !== 'undefined' && Number.isFinite(entry.rank) && entry.rank > 0)
		.map((entry) => ({ date: new Date(entry.date), rank: entry.rank }))
		.filter((entry) => Number.isFinite(entry.date.getTime()))
		.sort((a, b) => a.date.getTime() - b.date.getTime());
	if (!observations.length) return { id, status: 'missing' };
	const months: Map<string, { count: number; sum: number; min: number; max: number }> = new Map();
	for (const entry of observations) {
		const month = entry.date.toISOString().slice(0, 7);
		const stats = months.get(month) || { count: 0, sum: 0, min: entry.rank, max: entry.rank };
		stats.count++; stats.sum += entry.rank;
		stats.min = Math.min(stats.min, entry.rank); stats.max = Math.max(stats.max, entry.rank);
		months.set(month, stats);
	}
	return {
		id, status: 'available', firstObservedAt: observations[0].date.toISOString(), lastObservedAt: observations[observations.length - 1].date.toISOString(),
		observationCount: observations.length, totalMonths: months.size,
		monthly: [...months.entries()].slice(-36).map(([month, stats]) => ({ month, observations: stats.count, averageBsr: Math.round(stats.sum / stats.count), bestBsr: stats.min, worstBsr: stats.max }))
	};
}
